<template>
  <div class="c-toggle">
    <label class="c-toggle__switch">
      <input type="checkbox" :checked="value" @change="handleToggle" />
      <span class="c-toggle__switch__slider"></span>
      <span class="c-toggle__label">{{label}}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "FormToggle",

  methods: {
    handleToggle(e) {
      this.$emit("toggle", e.target.checked);
      this.$emit("input", e.target.checked);
    }
  },
  props: {
    value: {
      type: [Boolean, Number],
      default: false
    },
    label: String
  }
};
</script>

<style scoped lang="scss">
.c-toggle {
  display: inline-flex;
  align-items: center;

  &__label {
    margin-left: 70px;
  }
  &__switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 34px;
    width: auto;

    [type="checkbox"] {
      position: absolute;
      left: 10px;

      &:focus {
        + .c-toggle__switch__slider {
          outline: #7dadd9 auto 5px; 
        }
      }

      &:checked {
        + .c-toggle__switch__slider {
          background: $colour-nhs-core-blue;
          &:before {
            transform: translateX(26px);
          }
        }
      }
    }

    &__slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      background: $colour-nhs-mid-grey;
      transition: 0.4s;
      border-radius: 34px;
      width: 60px;
      height: 100%;

      &:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background: $colour-nhs-core-white;
        transition: 0.4s;
        border-radius: 34px;
      }
    }
  }
}
</style>